import type { SVGProps } from 'react';

const ImageKeyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    {...props}
  >
    <path
      d="M3.46106 23.5252L6.60309 20.3831C7.84053 19.1457 9.79264 18.988 11.2127 20.0107V20.0107C12.822 21.1698 15.0677 20.7946 16.2127 19.1752L19.48 14.5543C21.4051 11.8315 25.5181 12.0706 27.1149 14.998V14.998"
      stroke="#2563EB"
      strokeWidth="1.15385"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="11.2186"
      cy="10.1223"
      r="2.12433"
      stroke="#2563EB"
      strokeWidth="1.39236"
      strokeLinejoin="round"
    />
    <rect
      x="2.8843"
      y="0.576923"
      width="24.2308"
      height="28.8462"
      rx="4.42308"
      stroke="#112A55"
      strokeWidth="1.15385"
    />
  </svg>
);

export default ImageKeyIcon;
